module.exports = __webpack_public_path__ + "img/rec-13.74e130bf.jpg";